import { ThemeProvider, createTheme } from '@mui/material/styles';
import { PropsWithChildren } from 'react';

import type {} from '@mui/x-data-grid-pro/themeAugmentation';
import { vdsTheme } from '@verantos-dev/shared-ui-components/styles';

import { muiAppBarThemeConfig } from '../themes/muiAppBarThemeConfig';
import { muiButtonThemeConfig } from '../themes/muiButtonThemeConfig';
import { muiChipThemeConfig } from '../themes/muiChipThemeConfig';
import { dataGridThemeConfig, tableRowThemeConfig } from '../themes/muiDataGridThemeConfig';
import { muiListItemThemeConfig } from '../themes/muiListItem';
import { muiMenuThemeConfig } from '../themes/muiMenuThemeConfig';
import { muiTypographyThemeConfig } from '../themes/muiTypographyThemeConfig';

export const theme = createTheme(vdsTheme, {
  components: {
    ...muiTypographyThemeConfig,
    ...muiAppBarThemeConfig,
    ...muiButtonThemeConfig,
    ...muiMenuThemeConfig,
    MuiDataGrid: {
      ...dataGridThemeConfig,
    },
    MuiTableRow: {
      ...tableRowThemeConfig,
    },
    ...muiChipThemeConfig,
    ...muiListItemThemeConfig,
  },
});

export const AppThemeProvider = (props: PropsWithChildren) => {
  return <ThemeProvider theme={theme}>{props.children}</ThemeProvider>;
};

export default AppThemeProvider;
